import {Icon, IconProps} from '@chakra-ui/react';

// Icones pour le statut d'evolution de tendance d'un article

// Cercle plein — utilisé pour les statuts `gagne` / `perdu` / `pas-commande`.
// La couleur est portée par la prop `color` (fill via currentColor).
export const DotIcon: React.FC<IconProps> = (props) => (
  <Icon
    viewBox='0 0 10 10'
    {...props}
  >
    <circle
      cx='5'
      cy='5'
      r='4'
      fill='currentColor'
    />
  </Icon>
);

// Tiret horizontal — utilisé pour le statut `stable` (ligne stable / même quantité).
export const HorizontalDashIcon: React.FC<IconProps> = (props) => (
  <Icon
    viewBox='0 0 10 10'
    {...props}
  >
    <rect
      x='1'
      y='4'
      width='8'
      height='2'
      rx='1'
      fill='currentColor'
    />
  </Icon>
);
